import { render, staticRenderFns } from "./raffleRegister.vue?vue&type=template&id=64ac8b6b&scoped=true"
import script from "./raffleRegister.vue?vue&type=script&lang=js"
export * from "./raffleRegister.vue?vue&type=script&lang=js"
import style0 from "./raffleRegister.vue?vue&type=style&index=0&id=64ac8b6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac8b6b",
  null
  
)

export default component.exports